<template>
  <dd
    @mouseenter="hoverItem"
    @mouseleave="leaveItem"
    @click.stop="selectOptionClick"
    @mousedown="selectOptionMouseDown"
    @keydown.enter="selectOptionClick"
    class="zm-select-dropdown__item"
    v-if="visible"
    :id="optionId"
    role="option"
    :aria-selected="itemSelected ? 'true' : 'false'"
    :aria-label="ariaLabel || currentLabel"
    ref="optionLi"
    tabindex="-1"
    :class="[{
               'selected': itemSelected,
               'hover': hover,
               'is-disabled': computedDisabled || groupDisabled || limitReached
             },
             optionSize ? 'zm-select-dropdown__item--' + optionSize : '']"
  >
    <div class="zm-select-dropdown__item--content">
      <slot>
        <!--        <span ref="realLabelSpan" class="real-label-span" aria-hidden="true">{{ currentLabel }}</span>-->
        <span v-if="!widthLimit">
          {{ currentLabel }}
        </span>
        <div v-else>
          <zm-tooltip
            v-if="hasTips"
            ref="tooltips"
            :open-delay="0"
            :modifiers="{flip: true}"
            popper-class="zm-select-dropdown__item__tooltips"
            placement="right"
          >
            <div slot="content" class="zm-select-dropdown__item__tooltips__content" v-text="currentLabel"></div>
            <span>
              <span class="zm-select-dropdown__label_span" :style="{width: itemWidth + 'px'}">{{ currentLabel }}</span>
            </span>
          </zm-tooltip>
          <span v-else class="zm-select-dropdown__label_span">{{ currentLabel }}</span>
        </div>
      </slot>
    </div>
    <template v-if="tooltipContent && tooltipContent.length">
      <zm-tooltip placement="top">
        <div slot="content" class="zm-select-dropdown__item__tooltips__content" v-html="tooltipContent"></div>
        <span aria-hidden class="zm-select-dropdown__item--tooltips zm-icon-help-outline"></span>
      </zm-tooltip>
    </template>
  </dd>
</template>
<script>
import Option from '@zoom/zoom-ui/src/components/select/option.vue';

export default {
  name: 'opc-option',
  extends: Option,
};
</script>
